import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'

type FiltersFooterProps = {
  onFilterApply: () => void
  onFilterClear: () => void
}

export default function FiltersFooter({
  onFilterApply: handleFilterApply,
  onFilterClear: handleFilterClear
}: FiltersFooterProps) {
  return (
    <div className={styles.footer}>
      <Button variant="primary" fullWidth="always" onClick={handleFilterApply}>
        View products
      </Button>
      <Button
        variant="secondary"
        fullWidth="always"
        onClick={handleFilterClear}
      >
        Clear
      </Button>
    </div>
  )
}
